import React from "react"
import './Instructions.scss'

export type InstructionsProps = {
    instructions: string
}

const Instructions = (props: InstructionsProps) => {
    const formattedText = formatTextWithLinks(props.instructions)
    return (
        <div className='instructions'>
            {formattedText}
        </div>
    )
}

function formatTextWithLinks(text: string) {
    const urlRegex = /(https?:\/\/[^\s]+)/g
    const parts = text.split(urlRegex)

    return parts.map((part, index) => {
        if (part.match(urlRegex)) {
            return (
                <a key={index} href={part} target="_blank" rel="noreferrer">
                    {part}
                </a>
            )
        } else {
            return (
                <span key={index}>
                    {part}
                </span>
            )
        }
    })
}

export default Instructions